import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-499ac1e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "asnchor"
}
const _hoisted_2 = { class: "asnchor-user" }
const _hoisted_3 = {
  key: 0,
  class: "asnchor-user-left"
}
const _hoisted_4 = { class: "avatar" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "nickname van-ellipsis" }
const _hoisted_8 = { class: "fsBox" }
const _hoisted_9 = {
  key: 1,
  class: "asnchor-name-right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.props.roomdata)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          ($setup.props.type == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("img", {
                    class: "img",
                    fit: "cover",
                    "lazy-load": "",
                    src: $setup.props.roomdata.portrait,
                    alt: ""
                  }, null, 8 /* PROPS */, _hoisted_5)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString($setup.props.roomdata.nickname), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('play.fensi') + $setup.props.roomdata.fans_number), 1 /* TEXT */)
                ])
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.props.type == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("span", {
                  style: _normalizeStyle({ 'background': $setup.primaryColor })
                }, _toDisplayString(_ctx.$t('play.sixin')), 5 /* TEXT, STYLE */)
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ]))
    : _createCommentVNode("v-if", true)
}